
import { OioButton } from '@kunlun/vue-ui-antd';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Action',
  components: {
    OioButton
  },
  inheritAttrs: false,
  props: ['backFormData', 'saveFormData', 'hasDraft', 'invisible', 'saveLoading', 'backLoading']
});
